import { render, staticRenderFns } from "./setting-upload.vue?vue&type=template&id=359165ac&scoped=true&"
import script from "./setting-upload.vue?vue&type=script&lang=js&"
export * from "./setting-upload.vue?vue&type=script&lang=js&"
import style0 from "./setting-upload.vue?vue&type=style&index=0&id=359165ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359165ac",
  null
  
)

export default component.exports